type Props = {
  className?: string
  width?: number
  height?: number
}

export const ArrowIcon = ({ className, width = 71, height = 31 }: Props) => {
  return (
    <span className={className}>
      <svg width={width} height={height} viewBox="0 0 71 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.833496 15.1279L70.8335 15.1279" stroke="white" strokeWidth="0.961832" />
        <path
          d="M55.3359 0.16626C55.3359 5.2426 58.3817 15.3953 70.5649 15.3953"
          stroke="white"
          strokeWidth="0.961832"
        />
        <path
          d="M55.3359 30.6243C55.3359 25.5479 58.3817 15.3953 70.5649 15.3953"
          stroke="white"
          strokeWidth="0.961832"
        />
      </svg>
    </span>
  )
}
